export default __webpack_public_path__ + "static/media/Tasset of the Bloodhunter (nm).d7947d6d.jpg";